import type { UserValidationError } from "../types";

const VALIDATE_USER_PATH = "/api/validate-user";

const validateUser = async (
  intouchEndpoint: string,
  userEmail: string,
  market: string
): Promise<UserValidationError | undefined> => {
  const apiUrl = new URL(intouchEndpoint);
  apiUrl.pathname = VALIDATE_USER_PATH;

  try {
    const response = await fetch(apiUrl.href, {
      method: "POST",
      body: new URLSearchParams({
        email: userEmail,
        role: "GENERAL",
        market
      }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });

    if (!response.ok) {
      return;
    }

    const parsedResponse: { data: UserValidationError } = await response.json();

    return parsedResponse.data;
  } catch (err) {
    console.error("Did not manage to validate user", err);
  }
};

export default validateUser;
